/**
 * Which attached names/URLs the ticket can open in StylishViewFileDialog
 * (PDF via the doc viewer, Word via docx-preview).
 */

export const WORD_OOXML_MIME =
  'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

const pathOf = (value: string): string =>
  value.trim().toLowerCase().split('?')[0] ?? '';

export function isPreviewableDocument(
  nameOrUrl?: string | null,
  mime?: string | null
): boolean {
  const path = pathOf(nameOrUrl ?? '');
  const mimeLower = (mime ?? '').toLowerCase();
  return (
    path.endsWith('.pdf') ||
    path.endsWith('.docx') ||
    path.endsWith('.doc') ||
    mimeLower.includes('pdf') ||
    mimeLower.includes('word') ||
    mimeLower.includes('officedocument.wordprocessingml')
  );
}

export function previewMimeType(
  nameOrUrl?: string | null,
  mime?: string | null
): string {
  const path = pathOf(nameOrUrl ?? '');
  const mimeLower = (mime ?? '').toLowerCase();
  if (
    path.endsWith('.docx') ||
    path.endsWith('.doc') ||
    mimeLower.includes('word') ||
    mimeLower.includes('officedocument.wordprocessingml')
  ) {
    return WORD_OOXML_MIME;
  }
  return mime && mimeLower.includes('pdf') ? mime : 'application/pdf';
}
